/**
 * Ensures RAG step inputs match BeX Server Joi requirements before save / wire emit.
 * search_with_files requires inputs.top_n (string OEL).
 */

export function ensureRagStepWireInputs(step: Record<string, unknown> | null | undefined) {
    if (!step || step.kind !== 'rag') return step;

    const operation = (step.operation as string) || 'basic_search';
    const inputs = {
        ...(step.inputs as Record<string, unknown> | undefined)
    };

    if (operation === 'search_with_files') {
        if (inputs.top_n === '' || inputs.top_n == null) {
            inputs.top_n = '3';
        }
        if (inputs.top_k === '' || inputs.top_k == null) {
            inputs.top_k = '10';
        }
        if (inputs.use_rerank == null) {
            inputs.use_rerank = 'false';
        }
    }

    return {
        ...step,
        inputs
    };
}

export function ensureRagStepTree(step: Record<string, unknown> | null | undefined) {
    if (!step) return step;

    let next = ensureRagStepWireInputs(step) as Record<string, unknown>;

    if (next.kind === 'parallel' && Array.isArray(next.branches)) {
        next = {
            ...next,
            branches: next.branches.map((branch) => ensureRagStepTree(branch as Record<string, unknown>))
        };
    }

    return next;
}

export function ensureRagStepsInOpcode(opcode: Record<string, unknown> | null | undefined) {
    if (!opcode) return opcode;

    const out = { ...opcode };

    if (Array.isArray(out.steps)) {
        out.steps = out.steps.map((s) => ensureRagStepTree(s as Record<string, unknown>));
    }
    if (Array.isArray(out.definitions)) {
        out.definitions = out.definitions.map((s) => ensureRagStepTree(s as Record<string, unknown>));
    }
    if (Array.isArray(out.flows)) {
        out.flows = out.flows.map((flow) => {
            if (!flow || typeof flow !== 'object') return flow;
            const f = flow as Record<string, unknown>;
            return {
                ...f,
                steps: Array.isArray(f.steps)
                    ? f.steps.map((s) => ensureRagStepTree(s as Record<string, unknown>))
                    : []
            };
        });
    }

    return out;
}
